import React from "react";
import { Alert, Button, Stack, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import { AxiosError } from "axios";
import apiClient from "../../../utils/apiClient";
import { AgentFormState } from "../../../types/agentTypes";
import {
  FieldColumn,
  FieldRow,
  Section,
  SectionTitle,
  StyledDatePicker,
} from "../styles";

type CloseAgentSectionProps = {
  agent: any;
  formData: AgentFormState;
  setFormData: React.Dispatch<React.SetStateAction<AgentFormState>>;
  onSuccess: () => void;
};

const CloseAgentSection = ({
  agent,
  formData,
  setFormData,
  onSuccess,
}: CloseAgentSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t("createAgent.closeAgent.title")}</SectionTitle>

      <FieldRow>
        <FieldColumn>
          <StyledDatePicker
            value={formData.data_end_doc ? dayjs(formData.data_end_doc) : null}
            label={t("createAgent.closeAgent.closeDate")}
            onChange={(date) => {
              const typedDate = date as Dayjs | null;

              setFormData((prev) => ({
                ...prev,
                data_end_doc: typedDate ? typedDate.format("YYYY-MM-DD") : "",
              }));
            }}
            format="DD.MM.YYYY"
          />
        </FieldColumn>

        <FieldColumn>
          {!formData.is_o ? (
            <Alert icon={false} color="error">
              {t("createAgent.closeAgent.closed")}
            </Alert>
          ) : (
            <Stack direction="row" spacing={1}>
              <Tooltip
                arrow
                title={
                  !formData.data_end_doc
                    ? t("createAgent.closeAgent.specifyCloseDate")
                    : t("createAgent.closeAgent.close")
                }
              >
                <div>
                  <Button
                    variant="contained"
                    color="error"
                    disabled={!formData.data_end_doc}
                    onClick={async () => {
                      try {
                        const resp = await apiClient.put(
                          `/agents/${agent.id}/close`,
                          {
                            data_end_doc: formData.data_end_doc,
                          },
                        );

                        if (resp.data.status === "ok") {
                          alert(t("createAgent.closeAgent.closed"));
                          onSuccess();
                        }
                      } catch (err) {
                        console.error(
                          t("createAgent.closeAgent.closeErrorLog"),
                          err,
                        );
                        alert(
                          (err as AxiosError<any>)?.response?.data?.error ??
                            t("createAgent.closeAgent.closeError"),
                        );
                      }
                    }}
                    sx={{ height: 41 }}
                  >
                    {t("createAgent.closeAgent.close")}
                  </Button>
                </div>
              </Tooltip>
            </Stack>
          )}
        </FieldColumn>
      </FieldRow>
    </Section>
  );
};

export default CloseAgentSection;
